import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { OrderDetails } from "../../orders.types";
import { requestOrdersDetailsByIds } from "./ordersDetailsByIds.request";

const useOrdersDetailsByIds = (
  options?: MutationOptions<OrderDetails[], ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestOrdersDetailsByIds,
    ...options
  });
};

export default useOrdersDetailsByIds;
